import { push } from '@takeshape/redux-little-router';
import { setProjectEndpoint } from 'app/graphql-client';
import { showMessage } from 'app/messages/actions';
import { getCurrentProjectId } from 'app/project';
import type { SagaIterator } from 'redux-saga';
import { put, select, takeLatest } from 'redux-saga/effects';
import type { ActionType } from 'typesafe-actions';
import { getRouter } from '../../selectors.js';
import { fetchSchemaRoutine, setCurrentBranch, setUseScratchForPreview } from '../actions.js';
import { createBranchPath } from '../utils.js';

export function* setCurrentBranchSaga(action: ActionType<typeof setCurrentBranch>): SagaIterator {
  const { branch, message, snackbarMessage = true } = action.payload;
  const projectId = yield select(getCurrentProjectId);
  const router = yield select(getRouter);
  setProjectEndpoint(projectId, branch);
  if (branch !== router.params.branch) {
    yield put(
      push(router.pathname.replace(/\/project\/[^/]+\/branch\/[^/]+/, createBranchPath(projectId, branch)), {
        persistQuery: true
      })
    );
  }

  yield put(fetchSchemaRoutine.requested(undefined, { branch, runtime: true }));
  yield put(setUseScratchForPreview(false));
  if (snackbarMessage) {
    yield put(showMessage('info', message ?? `Switched to branch "${branch}"`, 3000));
  }
}

export default function* root(): SagaIterator {
  yield takeLatest(setCurrentBranch, setCurrentBranchSaga);
}
